import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const TrashBinIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.66666 4.66667H13.3333M3.33332 4.66667L3.99999 12.6667C3.99999 13.0203 4.14047 13.3594 4.39051 13.6095C4.64056 13.8595 4.9797 14 5.33332 14H10.6667C11.0203 14 11.3594 13.8595 11.6095 13.6095C11.8595 13.3594 12 13.0203 12 12.6667L12.6667 4.66667M5.99999 4.66667V2.66667C5.99999 2.48986 6.07023 2.32029 6.19525 2.19526C6.32028 2.07024 6.48985 2 6.66666 2H9.33332C9.51013 2 9.6797 2.07024 9.80473 2.19526C9.92975 2.32029 9.99999 2.48986 9.99999 2.66667V4.66667M6.66666 8L9.33332 10.6667M9.33332 8L6.66666 10.6667"
          stroke="#FF7C75"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
